import * as Constants from "../../constants/urls";
import { Backdrop, Button, Fade, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { useCookies } from "react-cookie";
import Alerts from "../Alerts";
import { DatePicker } from "zaman";
import { DropzoneArea } from "material-ui-dropzone";
import axios from "axios";
import dateFormat from "dateformat";
import Tr from "./Tr";
import "./Table.css";

export default function BannerTable() {
    const [alert, setAlert] = useState(false);
    const [open, setOpen] = useState(false);
    const [alertType, setAlertType] = useState("alert-success");
    const [alertMassage, setAlertMassage] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [total, setTotal] = useState(11);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState(null);
    const [bigImg, setBigImg] = useState(null);
    const [smallImg, setSmallImg] = useState(null);
    const [link, setLink] = useState("");
    const [title, setTitle] = useState("");
    const [banners, setBanners] = useState(null);
    const [cookies, setCookie, removeCookie] = useCookies();
    const [loading, setLoading] = useState(false);

    async function getHeaderBanners(page = 1) {
        const url = Constants.apiUrl + `/api/all_header_banners?page=${page}`;
        setCurrentPage(page);
        await axios
            .get(`${url}`, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((response) => {
                console.log(response);
                if (response.data.status == "failed") {
                    // window.location.href = "https://honari.com";

                    setAlertMassage(response.data.message);
                    alert_on();
                    setAlertType("alert-danger");
                } else {
                    setBanners(response.data.data);
                }
            })
            .catch((error) => {
                alert_on();
                setAlertType("alert-danger");
                setAlertMassage("خطایی رخ داده است !");
                console.log(error);
            });
    }

    useEffect(() => {
        getHeaderBanners();
    }, []);

    function alert_on() {
        setAlert(true);
    }

    function alert_off() {
        setAlert(false);
    }

    const handleDatepicker = ({ from, to }) => {
        let start = new Date(from);
        let end = new Date(to);
        setStartDate(dateFormat(start, "yyyy/mm/dd"));
        setEndDate(dateFormat(end, "yyyy/mm/dd"));
    };

    // const handleCloseModal = (event, reason) => {
    //     handleModal();
    // };

    const handleAddedMessage = (fileName) => {
        return `با موفقیت افزوده شد ${fileName} فایل`;
    };

    const handleRemovedMessage = (fileName) => {
        return `با موفقیت حذف شد ${fileName} فایل`;
    };

    const handleAddImage = (file, type) => {
        if (file.length) {
            switch (type) {
                case "big":
                    setBigImg(file[0]);
                    break;
                case "small":
                    setSmallImg(file[0]);
                    break;
            }
        }
    };

    const checkEmpty = (formData) => {
        for (const value of formData.values()) {
            if (value !== undefined && value !== null && value.length <= 0) {
                return true;
            }
        }
        return false;
    };

    const mp =
        banners != null &&
        banners.map((banner) => {
            return (
                <Tr
                    key={banner.id}
                    id={banner.id}
                    title={banner.title}
                    link={banner.link}
                    start={banner.start}
                    end={banner.end}
                    img_b={banner.img_b}
                    img_s={banner.img_s}
                    status={banner.status}
                    checkEmptyEdit={checkEmpty}
                    alert={alert_on}
                    alert_message={setAlertMassage}
                    alert_type={setAlertType}
                    // edit={savehandler}
                />
            );
        });

    const handleModal = () => {
        if (!open) {
            setLink("");
            setTitle("");
        }
        setOpen(!open);
    };

    const handleForm = (e) => {
        e.preventDefault();
        const url = Constants.apiUrl + "/api/create_banner";
        const formData = new FormData();
        formData.append("image_s", smallImg);
        formData.append("image_b", bigImg);
        formData.append("link", link);
        formData.append("title", title);
        formData.append("startDate", startDate);
        formData.append("endDate", endDate);
        if (checkEmpty(formData)) {
            setAlertMassage(".لطفا فیلدهای تاریخ و عکس را خالی نگذارید");
            setAlertType("alert-danger");
            alert_on();
        }
        setLoading(true);
        axios
            .post(url, formData, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                console.log(response);
                if (response.data.status == "failed") {
                    setAlertMassage(response.data.message);
                    alert_on();
                    setAlertType("alert-danger");
                } else {
                    setBanners([...banners, response.data]);
                    setOpen(false);
                    setLink("");
                    setTitle("");
                }
                setLoading(false);
            })
            .catch(({ response }) => {
                console.log(response);
                if (response.status === 422) {
                    alert_on();
                    setAlertType("alert-danger");
                    for (const key in response.data.errors) {
                        if (
                            Object.hasOwnProperty.call(
                                response.data.errors,
                                key,
                            )
                        ) {
                            const message = response.data.errors[key][0];
                            alert_on();
                            setAlertType("alert-danger");
                            setAlertMassage(message);
                        }
                    }
                } else {
                    alert_on();
                    setAlertType("alert-danger");
                    setAlertMassage("خطایی رخ داده است !");
                }
                setLoading(false);
            });
    };

    const linkHandler = (e) => {
        setLink(e.target.value);
    };

    const titleHandler = (e) => {
        setTitle(e.target.value);
    };

    return (
        <>
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={open}
                onClose={handleModal}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotprops={{
                    backdrop: {
                        TransitionComponent: Fade,
                    },
                }}
                sx={{ overflow: "auto" }}
                // onClose={handleCloseModal}
            >
                <Fade in={open}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content p-3 text-center">
                            {alert == true && (
                                <Alerts
                                    type={alertType}
                                    text={alertMassage}
                                    close={alert_off}
                                />
                            )}
                            <form onSubmit={handleForm}>
                                <div>
                                    <DatePicker
                                        inputClass="bannerModalInputs"
                                        direction="ltr"
                                        round="x2"
                                        accentColor="#6374ae"
                                        onChange={handleDatepicker}
                                        range
                                    />
                                </div>
                                <div>
                                    <input
                                        value={link}
                                        onChange={linkHandler}
                                        className="bannerModalInputs mt-4"
                                        placeholder="لینک مربوطه را وارد کنید"
                                        type="text"
                                    />
                                </div>
                                <div>
                                    <input
                                        value={title}
                                        onChange={titleHandler}
                                        className="bannerModalInputs mt-4"
                                        placeholder="عنوان مربوطه را وارد کنید"
                                        type="text"
                                    />
                                </div>
                                <div className="my-4">
                                    <DropzoneArea
                                        acceptedFiles={["image/*"]}
                                        filesLimit={1}
                                        dropzoneText={
                                            "Drag and drop an image here or click for big devices"
                                        }
                                        onChange={(files) =>
                                            handleAddImage(files, "big")
                                        }
                                        getFileAddedMessage={handleAddedMessage}
                                        getFileRemovedMessage={
                                            handleRemovedMessage
                                        }
                                    />
                                </div>
                                <div className="my-4">
                                    <DropzoneArea
                                        acceptedFiles={["image/*"]}
                                        filesLimit={1}
                                        dropzoneText={
                                            "Drag and drop an image here or click for small devices"
                                        }
                                        onChange={(files) =>
                                            handleAddImage(files, "small")
                                        }
                                        getFileAddedMessage={handleAddedMessage}
                                        getFileRemovedMessage={
                                            handleRemovedMessage
                                        }
                                    />
                                </div>
                                <Button
                                    disabled={loading}
                                    color="success"
                                    variant="contained"
                                    type="submit"
                                    className="btn btn-block"
                                >
                                    {loading ? "در حال افزودن..." : "افزودن"}
                                </Button>
                            </form>
                        </div>
                    </div>
                </Fade>
            </Modal>
            {alert == true && (
                <Alerts
                    type={alertType}
                    text={alertMassage}
                    close={alert_off}
                />
            )}
            <div className="container-fluid">
                <div className="table-responsive mt-5 mb-5">
                    <table className="table table-striped table-hover">
                        <thead className=" ">
                            <tr>
                                <th>عنوان</th>
                                <th>لینک</th>
                                <th>تاریخ شروع</th>
                                <th>تاریخ پایان</th>
                                <th>عکس بزرگ</th>
                                <th>عکس کوچک</th>
                                <th>وضعیت</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>{mp}</tbody>
                    </table>
                </div>
                <div className="link">
                    <button
                        onClick={handleModal}
                        className="btn-block btn-success text-center pt-2 pb-2 rounded"
                    >
                        افزودن بنر جدید
                    </button>
                </div>
                <div className="pager Page navigation example">
                    <Pagination
                        totalItemsCount={total}
                        activePage={currentPage}
                        itemsCountPerPage={perPage}
                        onChange={(number) => {
                            getHeaderBanners(number);
                        }}
                        itemClass="page-item"
                        linkClass="page-link"
                        firstPageText="اولین صفحه"
                        lastPageText="آخرین صفحه"
                        nextPageText="بعدی"
                        prevPageText="قبلی"
                        activeClass="pageactive"
                    />
                </div>
            </div>
        </>
    );
}
